module.exports = __webpack_public_path__ + "img/kafalah-pembiayaan-multiguna.4210edd9.jpg";